import { useDispatch, useSelector } from 'react-redux';
import { getSessionRole, USER_ROLE } from 'helpers/session';
import { useEffect } from 'react';
import { retrieveCreditProfile } from 'actions/creditInfo.actions';

export const useCreditInfo = () => {
  const creditInfoMeta = useSelector(state => state.creditInfo);
  const {
    creditInfo,
    creditInfoLoading: loading,
    creditInfoError: error,
  } = creditInfoMeta;
  const requestWillStart = !loading && !error && !creditInfo;
  const dispatch = useDispatch();
  const { ocfLoggedIn } = useSelector(state => ({
    ocfLoggedIn: state.app.ocfLoggedIn,
  }));
  const isUserSessionActive = getSessionRole() === USER_ROLE;

  const isOcfRole = ocfLoggedIn === true;

  useEffect(() => {
    if (requestWillStart && !isOcfRole && isUserSessionActive) {
      dispatch(retrieveCreditProfile()).then(data => {});
    }
  });

  return {
    creditInfo,
    loading,
    error,
  };
};
